module.exports = __webpack_public_path__ + "img/139.71352d93.jpg";